module.exports = __webpack_public_path__ + "static/media/mainExportTest.d90179d5.png";